<template>
  <!-- Compact gate status pill. Renders nothing when the gate is disabled. -->
  <span
    v-if="enabled"
    class="badge rounded-pill d-inline-flex align-items-center gap-1"
    :class="badgeClass"
    :title="tooltip"
  >
    <i class="fas" :class="iconClass"></i>
    <span class="dd-guard-badge-label">{{ label }}</span>
  </span>
</template>

<script>
export default {
  name: 'DrawdownGuardBadge',
  props: {
    guard: { type: Object, default: null },
  },
  computed: {
    enabled() {
      return !!this.guard?.enabled;
    },
    // 'off' | 'ok' | 'profit' | 'loss'
    status() {
      if (!this.enabled) return 'off';
      if (this.guard?.triggered) {
        return this.guard?.reason === 'LOSS_STOP' ? 'loss' : 'profit';
      }
      return 'ok';
    },
    badgeClass() {
      return {
        ok: 'bg-success-subtle text-success border border-success-subtle',
        profit: 'bg-success text-white',
        loss: 'bg-danger text-white',
      }[this.status] || 'bg-secondary-subtle text-secondary';
    },
    iconClass() {
      return {
        ok: 'fa-shield-halved',
        profit: 'fa-circle-check',
        loss: 'fa-ban',
      }[this.status] || 'fa-shield-halved';
    },
    label() {
      return {
        ok: 'Gate active',
        profit: 'Profit target hit',
        loss: 'Loss limit hit',
      }[this.status] || 'Gate';
    },
    tooltip() {
      const pct = Number(this.guard?.day_pnl_pct);
      const sign = Number.isFinite(pct) && pct > 0 ? '+' : '';
      const dp = Number.isFinite(pct) ? `${sign}${(pct * 100).toFixed(2)}%` : '—';
      return {
        ok: `Portfolio gate is enabled and monitoring. Day P&L: ${dp}.`,
        profit: `Daily profit target reached — new entries blocked and positions flattened (ratchet leaders keep running). Day P&L: ${dp}.`,
        loss: `Daily loss limit hit — new entries blocked and all positions closed for the session. Day P&L: ${dp}.`,
      }[this.status] || 'Portfolio gate';
    },
  },
};
</script>

<style scoped>
.dd-guard-badge-label {
  white-space: nowrap;
}
</style>
